"use strict";
/**
 * @file Created on 05.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NThresholdPromoVolume_1 = require("../model/NThresholdPromoVolume");

var NThresholdPromoVolumeConverter_1 = require("./NThresholdPromoVolumeConverter");
/**
 * @author Tomas Leity
 */


var NThresholdPromoVolumeConverterImpl =
/*#__PURE__*/
function (_NThresholdPromoVolum) {
  _inherits(NThresholdPromoVolumeConverterImpl, _NThresholdPromoVolum);

  function NThresholdPromoVolumeConverterImpl() {
    _classCallCheck(this, NThresholdPromoVolumeConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(NThresholdPromoVolumeConverterImpl).apply(this, arguments));
  }

  _createClass(NThresholdPromoVolumeConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new NThresholdPromoVolume_1.NThresholdPromoVolume(NThresholdPromoVolume_1.NThresholdPromoVolume.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), NThresholdPromoVolume_1.NThresholdPromoVolume.schema.productName.valueOf(source.productName), NThresholdPromoVolume_1.NThresholdPromoVolume.schema.productExternalId.valueOf(source.productExternalId), NThresholdPromoVolume_1.NThresholdPromoVolume.schema.promoVolume.valueOf(conversions.toBigNumber(source.promoVolume)), NThresholdPromoVolume_1.NThresholdPromoVolume.schema.systemVolume.valueOf(conversions.toBigNumber(source.systemVolume)), NThresholdPromoVolume_1.NThresholdPromoVolume.schema.promoVolumeAbsDiff.valueOf(conversions.toBigNumber(source.promoVolumeAbsDiff)), NThresholdPromoVolume_1.NThresholdPromoVolume.schema.promoVolumeRelDiff.valueOf(conversions.toBigNumber(source.promoVolumeRelDiff)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        productName: source.productName,
        productExternalId: source.productExternalId,
        promoVolume: conversions.fromBigNumber(source.promoVolume),
        systemVolume: conversions.fromBigNumber(source.systemVolume),
        promoVolumeAbsDiff: conversions.fromBigNumber(source.promoVolumeAbsDiff),
        promoVolumeRelDiff: conversions.fromBigNumber(source.promoVolumeRelDiff)
      });
      return result;
    }
  }]);

  return NThresholdPromoVolumeConverterImpl;
}(NThresholdPromoVolumeConverter_1.NThresholdPromoVolumeConverter);

exports.NThresholdPromoVolumeConverterImpl = NThresholdPromoVolumeConverterImpl;
/**
 * IOC Container qualifier
 */

NThresholdPromoVolumeConverterImpl.QUALIFIER = {
  documentType: NThresholdPromoVolume_1.NThresholdPromoVolume.name
};